<template>
    <div class="seperatorFW">
        <seperator />
    </div>
</template>

<script>
    import seperator from './seperator'

    export default {
        name: 'seperatorFW',
        components: {
            seperator
        }
    }

</script>

<style lang="scss" scoped>
    .seperatorFW{
        margin-left: -20px;
        width: calc(100vw + 20px);
        height: 14px;
}
</style>